import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IconifyService {
  private readonly scriptUrl = 'https://code.iconify.design/iconify-icon/2.0.0/iconify-icon.min.js';
  private scriptLoadPromise?: Promise<void>;

  constructor(@Inject(DOCUMENT) private readonly doc: Document) { }

  ensureLoaded(): Promise<void> {
    const win = this.doc.defaultView;
    if (!win) {
      return Promise.resolve();
    }

    if (win.customElements?.get('iconify-icon')) {
      return Promise.resolve();
    }

    if (!this.scriptLoadPromise) {
      this.scriptLoadPromise = new Promise<void>((resolve, reject) => {
        const existingScript = this.doc.querySelector<HTMLScriptElement>(`script[src="${this.scriptUrl}"]`);
        if (existingScript) {
          existingScript.addEventListener('load', () => resolve(), { once: true });
          existingScript.addEventListener('error', () => reject(), { once: true });
          return;
        }

        const script = this.doc.createElement('script');
        script.src = this.scriptUrl;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject();
        this.doc.body.appendChild(script);
      });
    }

    return this.scriptLoadPromise;
  }
}
